import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { SamplepoCopyLinesService } from "../../../../core/services/samplepo-copy-lines.service";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericRequestDto } from "../../../../core/models/generic-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { GetAllSamplePOWithLinesDto } from "../../../../core/models/samplePO/add/getAllSamplePOWithLinesDto";
import { GetAllSamplepo } from "../../../../core/models/samplePO/details/getAllSamplepo";
import { PurchaseOrderLineSummary } from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { DialogModule } from "primeng/dialog";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CopyPOLinesRequestDto } from "../../../../core/models/samplePO/details/copyPOLinesRequestDto";

@UntilDestroy()
@Component({
  selector: "jni-samplepo-copy-lines",
  templateUrl: "./samplepo-copy-lines.component.html",
  styleUrls: ["./samplepo-copy-lines.component.scss"],
  imports: [
    DialogModule,
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class SamplepoCopyLinesComponent {
  @Input() displayModal = false;
  @Input() samplePONumber = "";
  @Output() closeDialogEvent = new EventEmitter();
  @Output() refreshGridEvent = new EventEmitter();

  samplePOHeader: GetAllSamplePOWithLinesDto[] = [];
  selectedSamplePOHeader: GetAllSamplePOWithLinesDto[] = [];

  samplePOLine: PurchaseOrderLineSummary[] = [];
  selectedSamplePOLine: PurchaseOrderLineSummary[] = [];

  samplePOListings: GetAllSamplepo[] = [];
  selectedSamplePO: GetAllSamplepo[] = [];
  showLoader = false;
  lazyLoadEvent!: TableLazyLoadEvent;
  filterDebounceTime = 1000;
  filterTextChanged: Subject<Event> = new Subject<Event>();

  totalRecords = 0;
  defaultTake = 20;

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _samplepoCopyLinesService: SamplepoCopyLinesService,
    private _router: Router,
    private _samplepoListingService: SamplepoListingService,
    public _clientsListingService: ClientsListingService
  ) {}

  closeDialog() {
    this.selectedSamplePOHeader = [];
    this.selectedSamplePOLine = [];
    this.closeDialogEvent.emit();
  }

  // getSamplePoLines() {
  //   this._loaderService.setLoaderState(true);
  //   this._samplepoCopyLinesService.GetAllSamplePOWithLinesDto().subscribe({
  //     next: (res) => {
  //       this._loaderService.setLoaderState(false);
  //       if (res.data) {
  //         this.samplePOHeader = res.data;
  //       }
  //     },
  //     error: (res) => {
  //       this._loaderService.setLoaderState(false);
  //     }
  //   });
  // }

  // getLineAgainstHeader() {
  //   this.samplePOLine = [];
  //   if (this.samplePOHeader && this.samplePOHeader.length > 0) {
  //     const linesArray: PurchaseOrderLine[] = [];
  //     this.selectedSamplePOHeader.forEach((x) => {
  //       const index = this.samplePOHeader.findIndex(
  //         (y) => y.purchaseOrderNumber == x.purchaseOrderNumber
  //       );
  //       if (index > -1) {
  //         this.samplePOHeader[index].purchaseOrderLines?.forEach((a) => {
  //           linesArray.push(a);
  //         });
  //       }
  //     });
  //     this.samplePOLine = linesArray;
  //   }
  // }

  getCurrentSamplePo(accountnumber: string) {
    this._router.navigate(["/samplepo/samplepo-summary/" + accountnumber]);
  }

  onSamplePORedirection() {
    this._router.navigate(["samplepo/add-samplepo"]);
  }

  getAllSamplepoListingData(event: TableLazyLoadEvent) {
    this.samplePOLine = [];
    this.selectedSamplePOLine = [];
    this.samplePOListings = [];
    this.selectedSamplePO = [];

    this.lazyLoadEvent = event;
    this._loaderService.setLoaderState(true);
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      return {
        columnName: x ?? "",
        matchMode: event?.filters?.["matchMode"] ?? "",
        tableName: "",
        value: event?.filters?.["value"] ?? "",
      } as GenericFilterRequestDto;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    filter.forEach(x => {
      if (x.columnName == "purchaseOrderNumber") {
        x.columnName = "PurchaseOrderNumberD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "vendorName") {
        x.columnName = "VendorOrganizationNameD365";
        x.tableName = "Vendor";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobNameD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "bcName") {
        x.columnName = "FirstName,LastName";
        x.tableName = "Employee";
      }
      if (x.columnName == "status") {
        x.columnName = "PurchaseOrderStatusD365";
        x.tableName = "PurchaseOrderHeader";
      }
    });
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
    };

    this._samplepoListingService
      .getAllSamplePOPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.samplePOListings = res.data;
          this.totalRecords = res.totalRecords ?? 0;
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  purchaseOrderNumberArray: string[] = [];
  selectRow(checkValue: boolean, purchaseOrderNumber: string) {
    if (checkValue) {
      this.purchaseOrderNumberArray.push(purchaseOrderNumber);
      this.getLineAgainstSamplePOHeader(purchaseOrderNumber);
    } else {
      const index = this.purchaseOrderNumberArray.indexOf(purchaseOrderNumber);
      this.purchaseOrderNumberArray.splice(index, 1);
      this.deleteUnselectedLines();
    }
  }

  getLineAgainstSamplePOHeader(purchaseOrderNumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplepoCopyLinesService
      .getAllSamplePOLines(purchaseOrderNumber)
      .subscribe({
        next: res => {
          if (res.data) {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              let purchaseSamplePOLines: PurchaseOrderLineSummary[] = [];
              purchaseSamplePOLines = res.data;
              if (purchaseSamplePOLines.length > 0) {
                purchaseSamplePOLines.forEach(element => {
                  this.samplePOLine.push(element);
                });
              }
            } else {
              this._toastr.error("Error", res.message || "No line item found");
            }
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No line item found");
        },
      });
  }

  newSalesOrderLineArray: PurchaseOrderLineSummary[] = [];
  newSelectedSalesOrderLineArray: PurchaseOrderLineSummary[] = [];

  deleteUnselectedLines() {
    this.newSalesOrderLineArray = [];
    this.newSelectedSalesOrderLineArray = [];
    this._loaderService.setLoaderState(true);
    if (this.purchaseOrderNumberArray.length > 0) {
      this.purchaseOrderNumberArray?.forEach(x => {
        this.samplePOLine?.forEach(y => {
          if (y.purchaseOrderNumberD365 === x) {
            this.newSalesOrderLineArray.push(y);
          }
        });
        this.selectedSamplePOLine?.forEach(y => {
          if (y.purchaseOrderNumberD365 === x) {
            this.newSelectedSalesOrderLineArray.push(y);
          }
        });
      });
    }

    this.samplePOLine = [];
    this.samplePOLine = this.newSalesOrderLineArray;
    this.selectedSamplePOLine = [];
    this.selectedSamplePOLine = this.newSelectedSalesOrderLineArray;
    //this.onLineSelect();
    this._loaderService.setLoaderState(false);
  }

  saveLines() {
    this._loaderService.setLoaderState(true);
    const addUpdateSamplePOLineDto: CopyPOLinesRequestDto = {
      purchaseOrderLine: this.selectedSamplePOLine,
      purchaseOrderNumber: this.samplePONumber,
    };
    this._samplepoCopyLinesService
      .copyPOLines(addUpdateSamplePOLineDto)
      .subscribe({
        next: res => {
          if (res.data) {
            this.selectedSamplePOHeader = [];
            this.selectedSamplePOLine = [];
            this.refreshGridEvent.emit();
            this.closeDialog();
            this._loaderService.setLoaderState(false);
            this._toastr.success("Success", "Copy Line Successfully");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error Copying Lines");
        },
      });
  }

  onFilterInput($event: Event) {
    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllSamplepoListingData(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next($event);
  }
}
